import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitosaputaracabs() {



    const cardData = {





keyword: "Mumbai to Saputara Cabs",

headingDescription: "Shreesha Tours & Travels offers comfortable and affordable Mumbai to Saputara Cab Services for family vacations, weekend getaways, corporate trips, honeymoon travel, sightseeing tours, and outstation journeys. Our chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, and premium cab options provide a smooth and relaxing travel experience from Mumbai to Saputara. With experienced drivers, well-maintained vehicles, transparent pricing, flexible booking options, doorstep pickup, and 24/7 customer support, we ensure a safe and hassle-free journey. Whether you are planning a hill station holiday, nature trip, family tour, or group travel, Shreesha Tours & Travels provides reliable Mumbai to Saputara cab booking services with complete comfort and convenience.",

topPlaces: [
  {
    title: "Saputara Lake",
    description: "Saputara Lake is one of the most popular attractions in the hill station, offering boating, peaceful surroundings, and beautiful views. It is a perfect place for families and couples visiting Saputara."
  },
  {
    title: "Sunset Point Saputara",
    description: "Sunset Point is famous for breathtaking views of the sun setting over the Sahyadri hills. Tourists visit this location to enjoy scenic landscapes and memorable evening moments."
  },
  {
    title: "Saputara Ropeway",
    description: "The Saputara Ropeway offers panoramic views of valleys, forests, and mountains. It is a popular attraction for visitors looking for adventure and sightseeing experiences."
  },
  {
    title: "Gira Waterfalls",
    description: "Gira Waterfalls near Saputara is a beautiful natural attraction surrounded by greenery. It is especially popular during monsoon season for nature lovers and photographers."
  },
  {
    title: "Artist Village Saputara",
    description: "Artist Village showcases tribal art, handicrafts, traditional culture, and local lifestyle. It is an excellent place to explore the heritage of the Dang region."
  },
  {
    title: "Saputara Tribal Museum",
    description: "The Tribal Museum provides insights into the traditions, lifestyle, festivals, and culture of tribal communities living around Saputara."
  },
  {
    title: "Purna Wildlife Sanctuary",
    description: "Purna Wildlife Sanctuary is known for dense forests, wildlife, waterfalls, and natural beauty. It is an ideal destination for nature enthusiasts and adventure travelers."
  },
  {
    title: "Waghai Botanical Garden",
    description: "Waghai Botanical Garden features a wide variety of plants, trees, and beautiful landscapes. It is a peaceful attraction for families and nature lovers."
  },
  {
    title: "Vansda National Park",
    description: "Vansda National Park is a scenic forest destination near Saputara, known for rich biodiversity, greenery, and wildlife experiences."
  },
  {
    title: "Wilson Hills",
    description: "Wilson Hills is a charming hill station near Saputara famous for cool weather, viewpoints, and peaceful natural surroundings, making it a great addition to Gujarat hill tours."
  }
],




"services": [
  {
    "name": "Mumbai to Saputara Cab",
    "description": "Book Mumbai to Saputara Cab for a comfortable hill station journey with professional chauffeurs and well-maintained AC vehicles. Enjoy a smooth road trip from Mumbai to Saputara with Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cab options suitable for family vacations, weekend trips, and sightseeing tours."
  },
  {
    "name": "Mumbai to Saputara Taxi",
    "description": "Choose Mumbai to Saputara Taxi for safe and reliable travel to Gujarat's beautiful hill station. Get experienced drivers, comfortable vehicles, affordable fares, and flexible one way or round trip taxi services for a relaxing holiday journey."
  },
  {
    "name": "Mumbai to Saputara Cabs",
    "description": "Book Mumbai to Saputara Cabs for convenient and affordable hill station travel with multiple vehicle choices. Whether traveling with family, friends, or couples, enjoy spacious cars, professional drivers, and hassle-free transportation from Mumbai to Saputara."
  },
  {
    "name": "Mumbai to Saputara Cab Service",
    "description": "Choose Mumbai to Saputara Cab Service for dependable outstation travel with clean AC vehicles and experienced chauffeurs. Our cab services are ideal for vacations, sightseeing trips, family tours, and weekend getaways with comfortable travel solutions."
  },
  {
    "name": "Mumbai to Saputara Taxi Service",
    "description": "Book Mumbai to Saputara Taxi Service for a smooth and comfortable journey with trained drivers and premium vehicles. Enjoy reliable transportation with doorstep pickup, flexible schedules, and affordable packages for your Saputara trip."
  },
  {
    "name": "Mumbai to Saputara Cab Booking",
    "description": "Complete Mumbai to Saputara Cab Booking easily with quick confirmation and various vehicle options. Select Sedan, SUV, Ertiga, Innova, or premium cars according to your travel needs and enjoy a safe hill station journey."
  },
  {
    "name": "Mumbai to Saputara Car Rental",
    "description": "Choose Mumbai to Saputara Car Rental for chauffeur-driven vehicles designed for comfortable long-distance travel. Get spacious cars, professional drivers, and flexible rental plans for family trips, sightseeing, and holiday travel."
  },
  {
    "name": "Mumbai to Saputara Taxi Fare",
    "description": "Check Mumbai to Saputara Taxi Fare with transparent pricing and affordable travel options. Enjoy comfortable cab services with experienced chauffeurs, clean vehicles, and no hidden charges for your hill station journey."
  },
  {
    "name": "Mumbai to Saputara One Way Cab",
    "description": "Book Mumbai to Saputara One Way Cab for convenient drop taxi service without return fare charges. Travel comfortably with professional drivers, reliable vehicles, and flexible pickup options from Mumbai to Saputara."
  },
  {
    "name": "Mumbai to Saputara Round Trip Taxi",
    "description": "Reserve Mumbai to Saputara Round Trip Taxi for complete return travel with flexible timings and comfortable vehicles. Perfect for weekend holidays, family vacations, sightseeing tours, and extended stays at Saputara."
  },
  {
    "name": "Mumbai Airport to Saputara Cab",
    "description": "Choose Mumbai Airport to Saputara Cab for smooth airport transfer services with timely pickup and drop facilities. Enjoy luggage-friendly vehicles, experienced drivers, and comfortable travel from Mumbai Airport to Saputara."
  },
  {
    "name": "Mumbai to Saputara Outstation Cab",
    "description": "Book Mumbai to Saputara Outstation Cab for safe and reliable long-distance travel with premium vehicles and professional chauffeurs. Ideal for hill station tours, family trips, corporate travel, and private journeys."
  },
  {
    "name": "Mumbai to Saputara Tourist Cab",
    "description": "Hire Mumbai to Saputara Tourist Cab for exploring Saputara attractions with comfortable transportation and experienced drivers. Enjoy sightseeing, local travel, and complete holiday convenience with family and groups."
  },
  {
    "name": "Mumbai to Saputara Hill Station Taxi",
    "description": "Choose Mumbai to Saputara Hill Station Taxi for a relaxing journey to the scenic destination of Saputara. Travel safely with comfortable vehicles, skilled drivers, and customized cab packages for your hill station vacation."
  },
  {
    "name": "Mumbai to Saputara Innova Cab",
    "description": "Book Mumbai to Saputara Innova Cab for spacious and comfortable travel with premium seating and extra luggage capacity. Perfect for families and groups looking for a convenient hill station road trip."
  },
  {
    "name": "Mumbai to Saputara Ertiga Cab",
    "description": "Reserve Mumbai to Saputara Ertiga Cab for affordable group travel with comfortable seating and reliable performance. Ideal for family tours, small groups, and weekend trips from Mumbai to Saputara."
  },
  {
    "name": "Best Mumbai to Saputara Cab Service",
    "description": "Choose the Best Mumbai to Saputara Cab Service for safe, comfortable, and affordable hill station travel. Enjoy premium vehicles, trained chauffeurs, flexible booking options, and reliable service for family trips, sightseeing tours, and weekend getaways."
  }
],
"tableData": [
  ["Mumbai to Saputara Cab", "Mumbai to Saputara Taxi"],
  ["Mumbai to Saputara Cabs", "Mumbai to Saputara Cab Service"],
  ["Mumbai to Saputara Taxi Service", "Mumbai to Saputara Cab Booking"],
  ["Mumbai to Saputara Car Rental", "Mumbai to Saputara Taxi Fare"],
  ["Mumbai to Saputara One Way Cab", "Mumbai to Saputara Round Trip Taxi"],
  ["Mumbai Airport to Saputara Cab", "Mumbai to Saputara Outstation Cab"],
  ["Mumbai to Saputara Tourist Cab", "Mumbai to Saputara Hill Station Taxi"],
  ["Mumbai to Saputara Innova Cab", "Mumbai to Saputara Ertiga Cab"],
  ["Best Mumbai to Saputara Cab Service", ""]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Saputara Cab Service",
    WhyChoosedescription: "Shreesha Travels provides reliable Mumbai to Saputara cab services for families, couples, corporate travellers, and weekend explorers. Enjoy a relaxing hill station journey with comfortable vehicles, experienced chauffeurs, and flexible travel options."
  },
  {
    WhyChooseheading: "Smooth Journey to Gujarat's Popular Hill Station",
    WhyChoosedescription: "Travel from Mumbai to Saputara with complete convenience and enjoy attractions like Saputara Lake, Sunset Point, Artist Village, Gira Waterfall, and other scenic locations with a customized travel plan."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles Available",
    WhyChoosedescription: "Select from Sedan Cars, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other comfortable vehicles based on your group size and travel requirements."
  },
  {
    WhyChooseheading: "Ideal for Weekend Trips & Family Vacations",
    WhyChoosedescription: "Our Mumbai to Saputara taxis are perfect for weekend getaways, family holidays, honeymoon trips, nature tours, corporate outings, and customized Gujarat sightseeing packages."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "Choose a one-way cab for direct travel or select a round-trip package with flexible return timing, sightseeing stops, and multi-day travel arrangements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Hill Station Routes",
    WhyChoosedescription: "Our professional drivers understand highway routes and hill station travel requirements, ensuring safe driving, comfortable rides, and timely service throughout the journey."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Cars for Your Trip",
    WhyChoosedescription: "Every vehicle is regularly serviced, sanitized, air-conditioned, and inspected before departure to provide a smooth and enjoyable Mumbai to Saputara travel experience."
  },
  {
    WhyChooseheading: "Book Mumbai to Saputara Cabs with Shreesha Travels",
    WhyChoosedescription: "Get dependable cab booking support, transparent fares, comfortable vehicles, and professional chauffeur services for your Saputara hill station journey from Mumbai."
  }
]

};

const faqData = [
  {
    question: "Can I book a Mumbai to Saputara cab for a weekend trip?",
    answer: "Yes, Mumbai to Saputara cabs are available for weekend getaways, family holidays, couples trips, and customized sightseeing tours."
  },
  {
    question: "Is Mumbai to Saputara one-way cab service available?",
    answer: "Yes, one-way taxi bookings are available for travellers who need direct transportation from Mumbai to Saputara."
  },
  {
    question: "Which cars are available for Mumbai to Saputara travel?",
    answer: "We provide Sedan Cars, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other vehicles."
  },
  {
    question: "What places can I visit during a Saputara trip?",
    answer: "Popular attractions include Saputara Lake, Sunset Point, Gira Waterfall, Artist Village, Ropeway, Garden areas, and nearby sightseeing locations."
  },
  {
    question: "Is Saputara suitable for family travel?",
    answer: "Yes, Saputara is a family-friendly destination with pleasant weather, scenic views, and activities suitable for all age groups."
  },
  {
    question: "Can I customize my Mumbai to Saputara travel itinerary?",
    answer: "Yes, you can customize the route with sightseeing stops, hotel transfers, and additional destinations according to your plan."
  },
  {
    question: "Do you provide round-trip Mumbai to Saputara taxi service?",
    answer: "Yes, round-trip packages are available with flexible return schedules and customized travel options."
  },
  {
    question: "How is the Mumbai to Saputara cab fare calculated?",
    answer: "The fare depends on the vehicle type, travel distance, trip duration, route, waiting time, and selected package."
  },
  {
    question: "Can I book a cab for Saputara group tours?",
    answer: "Yes, Tempo Travellers and larger vehicles are available for group trips, family tours, and corporate outings."
  },
  {
    question: "How can I book Mumbai to Saputara Cabs with Shreesha Travels?",
    answer: "Share your travel date, pickup location, passenger count, preferred vehicle, and trip requirements to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akash Patil",
    feedback: "The Mumbai to Saputara journey was comfortable and well-organized. The driver was professional, the car was clean, and the entire hill station trip was enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Mehta",
    feedback: "Our family enjoyed a wonderful Saputara vacation with Shreesha Travels. The smooth ride, flexible stops, and excellent service made the trip memorable.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Saputara Cabs",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-saputara-cabs.webp",
  "description":
    "Book Mumbai to Saputara Cabs with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Saputara with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for family vacations, weekend trips, sightseeing tours, business travel, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-saputara-cabs"
  }
};









    return (
        <div>

<Helmet>
  <title>Mumbai to Saputara Cabs | One Way & Round Trip Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Saputara Cabs with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for Saputara sightseeing, family trips, weekend tours, and outstation travel with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Saputara Cab, Mumbai to Saputara Taxi, Mumbai to Saputara Cabs, Mumbai to Saputara Cab Service, Mumbai to Saputara Taxi Service, Mumbai to Saputara Cab Booking, Mumbai to Saputara Car Rental, Mumbai to Saputara Taxi Fare, Mumbai to Saputara One Way Cab, Mumbai to Saputara Round Trip Taxi, Mumbai Airport to Saputara Cab, Mumbai Saputara Outstation Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/65.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitosaputaracabs;